export class tipo_cuenta_bancaria {
    codigo : number;
    nombre : string;
    activado:boolean;
}